<template>
  <div>
    <NavCN/>
    <div class="main-container">
      <section class="large-image">
        <img src="../../../public/img/background-index.jpg">
      </section>
      <SliderCN/>
      <section class="company-introduce">
        <div class="background-image">
          <img src="img/background-index-company.jpg" class="background-image" draggable="false" style="display: none;">
        </div>
        <div class="company-container">
          <div class="tittle-row">
            <div class="tittle">
              <h5>公司简介</h5>
              <div class="under-line"></div>
            </div>
          </div>
          <div class="introduce-row">
            <div class="desc-box">
              <div class="desc-container">
                <h4>德鑫化工：中国食品添加剂主要供应商</h4>
                <p>
                  德鑫化工产品销售有限公司从事食品添加剂的销售活动，国内市场覆盖30个省、市、自治区，而且业务量逐年攀升。
                </p>
                <p>
                  2006年，公司邀请有关专家，对产品质量，销售网络，业务人才， 销售服务进行了多方面的论证。一致认为：开展国际业务,扩大经营范围的时机已经成熟 。随决定申请国际业务进出口权并获得成功的运作。 ...
                  <a href="company" class="btn">more>></a>
                </p>
              </div>
            </div>
            <div class="image-box">
              <img src="../../../public/img/company-left.jpg">
            </div>
          </div>
        </div>
      </section>
    </div>
    <FooterCN/>
  </div>
</template>

<script>

import NavCN from '@/components/nav-cn.vue'
import FooterCN from '@/components/footer-cn.vue'
import SliderCN from '@/components/slider-cn.vue'

export default {
  name: 'Home-CN',
  components: {
    NavCN,
    FooterCN,
    SliderCN
  }
}
</script>

<style lang="scss">
  .main-container {
    max-width: 1580px;
    margin: 0 auto;
    .large-image {
      background: #333;
      width: 100%;
      height: 100%;
      margin-bottom: 20px;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
        opacity: .7;
      }
    }
    .company-introduce {
      position: relative;
      padding: 20px 0 40px 0;
      .background-image {
        background: url(../../../public/img/background-index-company.jpg) 50% 50%;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        z-index: 0;
        opacity: .58 !important;
      }
      .company-container {
        @media(min-width: 768px) {
          width: 750px;
        }
        @media(min-width: 992px) {
          width: 970px;
        }
        @media(min-width: 1200px) {
          width: 1170px;
        }
        margin-left: auto;
        margin-right: auto;
        padding-left: 15px;
        padding-right: 15px;
        .tittle-row{
          width: 100%;
          height: 60px;
          .tittle {
            float: left;
            h5 {
              font-size: 20px;
              font-weight: 600;
              line-height: 28px;
              font-family: "Lucida Grande",Helvetica,Arial,"Microsoft YaHei",FreeSans,Arimo,"Droid Sans","wenquanyi micro hei","Hiragino Sans GB","Hiragino Sans GB W3",Roboto,Arial,sans-serif;
              margin-top: 0px;
              margin-bottom: 10px;
            }
            .under-line {
              width: 40px;
              height: 2px;
              background: #02328d;
              margin-bottom: 20px;
            }
          }
        }
        .introduce-row {
          position: relative;
          @media(min-width: 768px) {
            padding: 100px 0 10px;
          }
          .desc-box {
            background-color: white;
            width: 100%;
            padding-top: 15px;
            padding-bottom: 15px;
            margin-bottom: 10px;
            opacity: .8;
            .desc-container {
              padding: 0 15px;
              @media(min-width: 768px) {
                margin-left: 45%;
                width: 47%;
              }
              @media(min-width: 992px) {
                margin-left: 50%;
                width: 43%;
              }
              h4 {
                margin-top: 0;
                margin-bottom: 24px;
                font-size: 24px;
                font-weight: 300;
                line-height: 32px;
                color: #333;
              }
              p {
                margin-top: 0;
                margin-bottom: 0;
                text-align: left;
                text-indent:2em;
                font-size: 16px;
                font-weight: 400;
                line-height: 26px;
                color: rgb(119, 119, 119);
                a {
                  margin-left: 15px;
                  font-size: 12px;
                  font-weight: 700;
                  line-height: 26px;
                  text-transform: uppercase;
                  text-decoration-line: none;
                  color: #337ab7;
                  white-space: normal;
                  &:hover {
                    background-color: #337ab7;
                    color: white;
                    opacity: .7;
                  }
                }
              }
            }
          }
          .image-box {
            position: relative;
            @media(min-width: 768px){
              position: absolute;
              top: 0;
              left: 15px;
              text-align: left;
            }
            z-index: 2;
            img {
              @media(min-width: 768px) {
                max-width: 300px;
                max-height: 200px;
              }
              @media(min-width: 992px) {
                max-width: 446px;
                max-height: 276px;
              }
            }
          }
        }
      }
    }
  }

</style>
